/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Grid, SortDirection, Spinner, TableFooter, TableFooterProps, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { useMemo } from 'react'
import { Accordion } from 'react-accessible-accordion'

import HistoricoAtendimentoTableHeader from './header/HistoricoAtendimentoTableHeader'
import HistoricoAtendimentoTableItem from './item/HistoricoAtendimentoTableItem'

export interface HistoricoAtendimentoTableProps extends TableFooterProps {
  content: any // TIPAGEM PROVISÓRIA
  sort: SortDirection
  onSortChange(sort: SortDirection): void
}

export default function HistoricoAtendimentoTable(props: HistoricoAtendimentoTableProps) {
  const { content, sort, onSortChange, ...rest } = props
  const theme = useTheme()
  const classes = useMemo(() => styles(theme), [theme])

  const loading = false // Valor provisório
  const isEmpty = () => !content || content?.length === 0

  return (
    <VFlow style={classes.tableBox}>
      <HistoricoAtendimentoTableHeader sort={sort} onSortChange={onSortChange} />
      {loading && (
        <div css={classes.loadingContainer}>
          <Spinner />
          Carregando resultados
        </div>
      )}
      {!loading && isEmpty() && <Text styles={classes.noResultContainer}>A busca não econtrou resultados</Text>}
      <Accordion allowZeroExpanded={true} allowMultipleExpanded={true}>
        <Grid style={classes.accordionWrapper}>
          {content?.map((item: any, index: number) => (
            // Valor de data e key provisórios
            <HistoricoAtendimentoTableItem key={index} date={content[0] === item ? new Date(2021, 0, 1) : null} />
          ))}
        </Grid>
      </Accordion>
      <div css={classes.footerWrapper}>
        <TableFooter {...rest} style={classes.tableFooter} />
      </div>
    </VFlow>
  )
}

const styles = (theme: Theme) => {
  return {
    tableBox: css`
      border: 1px solid ${theme.pallete.divider};
      border-radius: ${theme.radius.modal};
    `,
    accordionWrapper: css`
      padding: 0.5rem 1rem;
    `,
    footerWrapper: css`
      border-top: 1px solid ${theme.pallete.divider};
    `,
    tableFooter: css`
      border: none;
    `,
    loadingContainer: css`
      color: ${theme.pallete.primary.main};
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      & > *:first-of-type {
        margin-right: 0.5rem;
      }
    `,
    noResultContainer: css`
      color: ${theme.pallete.text.secondary};
      font-style: italic;
      text-align: center;
    `,
  }
}
